import { TranslationDict } from "../types";

export const nlNavbar: TranslationDict = {
  bestand: "Bestand",
  nieuw: "Nieuw",
  open: "Openen",
  bewaar: "Bewaar",
  maakOfferte: "Maak offerte",
  maakOverzicht: "Maak overzicht",
  afwerking: "Afwerking",
  instellingen: "Instellingen",
  installateur: "Installateur",
  afmelden: "Afmelden",
  klant: "Klant",
  maakKlant: "Maak nieuwe klant",
  opties: "Opties",
  project: "Project",
};
